import React, { useEffect } from 'react'
import CatSection from '../../components/PageComps/HomeComps/CatSection/CatSection'
import BrowseCat from '../../components/PageComps/HomeComps/BrowseCat/BrowseCat'
import Hero from '../../components/PageComps/HomeComps/Hero/Hero'
import PopularProd from '../../components/PageComps/HomeComps/PopularProd/PopularProd'
import Features from '../../components/PageComps/HomeComps/Features/Features'
import AboutSection from '../../components/PageComps/HomeComps/AboutSection/AboutSection'
import Feautred from '../../components/PageComps/HomeComps/Featured/Featured'
import Carousel from '../../components/PageComps/HomeComps/Carousel/Carousel'
import { getAppearencesThunk } from '../../redux/appearancesSlice'
import { useDispatch, useSelector } from 'react-redux'

const Home = () => {

  const { appearences, loading } = useSelector((state) => state.appearences)

  return (
    <div>
      <Hero
        herobanner={appearences?.herobanner}
      />
      {/* Sab sections niche white background ke saath */}
      <div style={{ backgroundColor: '#ffffff', paddingTop: '1px' }}>
        <CatSection />
        <AboutSection />
        <Carousel
          sliders={appearences?.sliders?.sliders}
        />
        <BrowseCat
          topCategories={appearences?.categories?.categories}
        />
        {/* <Brands /> */}
        <Feautred data={appearences?.featuredBrand || []} />
        {
          appearences?.popularProducts?.length > 0 &&
          <PopularProd popproduct={appearences?.popularProducts} />
        }
        <Features />
      </div>
    </div>
  )
}

export default Home